import { CustomStatusQuery } from './CustomStatus.query';

const CustomStatus = () => {
  return <CustomStatusQuery />;
};

export { CustomStatus };
